import script from "./LoaderWithText.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderWithText.vue?vue&type=script&setup=true&lang=js"

import "./LoaderWithText.vue?vue&type=style&index=0&id=95acea0a&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95acea0a"]])

export default __exports__